import 'core-js/modules/es6.reflect.construct.js';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import * as React from 'react';
import { Divider, AbstractPureComponent2 } from '@blueprintjs/core';
import { DATEPICKER_CAPTION } from './common/classes.js';
import { clone } from './common/dateUtils.js';
import LazyYearSelect, { LazyMonthSelection } from './lazyYearSelect.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DatePickerCaption = /*#__PURE__*/function (_AbstractPureComponen) {
  _inherits(DatePickerCaption, _AbstractPureComponen);

  var _super = _createSuper(DatePickerCaption);

  function DatePickerCaption() {
    var _this;

    _classCallCheck(this, DatePickerCaption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.handleMonthSelectChange = _this.dateCustomChangeHandler(function (d, month) {
      return d.setMonth(month);
    }, _this.props.onMonthChange);
    _this.handleYearSelectChange = _this.dateCustomChangeHandler(function (d, year) {
      return d.setFullYear(year);
    }, _this.props.onYearChange);
    return _this;
  }

  _createClass(DatePickerCaption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          date = _this$props.date,
          locale = _this$props.locale,
          localeUtils = _this$props.localeUtils,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          _this$props$months = _this$props.months,
          months = _this$props$months === void 0 ? localeUtils.getMonths(locale) : _this$props$months;
      var monthSelect = /*#__PURE__*/React.createElement(LazyMonthSelection, {
        key: "lazy-month-select",
        date: date,
        minDate: minDate,
        maxDate: maxDate,
        months: months,
        onMonthChange: this.handleMonthSelectChange
      });
      var yearSelect = /*#__PURE__*/React.createElement(LazyYearSelect, {
        key: "lazy-year-select",
        date: date,
        onYearChange: this.handleYearSelectChange,
        minYear: minDate.getFullYear(),
        maxYear: maxDate.getFullYear()
      });
      var orderedSelects = this.props.reverseMonthAndYearMenus ? [yearSelect, monthSelect] : [monthSelect, yearSelect];
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.classNames.caption
      }, /*#__PURE__*/React.createElement("div", {
        className: DATEPICKER_CAPTION
      }, orderedSelects), /*#__PURE__*/React.createElement(Divider, null));
    }
  }, {
    key: "dateChangeHandler",
    value: function dateChangeHandler(updater, handler) {
      var _this2 = this;

      return function (e) {
        var value = parseInt(e.target.value, 10);

        _this2.updateDate(value, updater, handler);
      };
    }
  }, {
    key: "dateCustomChangeHandler",
    value: function dateCustomChangeHandler(updater, handler) {
      var _this3 = this;

      return function (value) {
        _this3.updateDate(value, updater, handler);
      };
    }
  }, {
    key: "updateDate",
    value: function updateDate(value, updater, handler) {
      var _this$props$onDateCha, _this$props2;

      // ignore change events with invalid values to prevent crash on iOS Safari (#4178)
      if (isNaN(value)) {
        return;
      }

      var newDate = clone(this.props.date);
      updater(newDate, value);
      (_this$props$onDateCha = (_this$props2 = this.props).onDateChange) === null || _this$props$onDateCha === void 0 ? void 0 : _this$props$onDateCha.call(_this$props2, newDate);
      handler === null || handler === void 0 ? void 0 : handler(value);
    }
  }]);

  return DatePickerCaption;
}(AbstractPureComponent2);

export { DatePickerCaption };
//# sourceMappingURL=datePickerCaption.js.map
